import axios from "axios";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import HeaderWithButton from "../Utility/HeaderWithButton";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "react-tooltip";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import { Dialog, Transition } from "@headlessui/react";
import { DataContext } from "../../helper/HelperOne";
import { Pagination } from "../../helper/HelperTwo";
import { useToast } from "../../context/ToastProvider";
import { KeyIcon } from "@heroicons/react/24/solid";

function Salesman() {
  const user = JSON.parse(localStorage.getItem("user"));
  // const leadTypeOfWorkPermission = user?.settings_role_based_access?.some(
  //   (access) => access.label_id == 5 && access.label_value != 0
  // );
  const { triggerToast } = useToast();
  const { searchData } = useContext(DataContext);
  const [currentPage, setCurrentPage] = useState(1);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);
  const [leadTypeOfWorkButton, setLeadTypeOfWorkButton] = useState("");
  const [leadTypeOfWorkData, setLeadTypeOfWorkData] = useState([]);
  const [editleadTypeOfWork, setEditleadTypeOfWork] = useState("");
  const [errors, setErrors] = useState("");
  const [paginationLeadTypeOfWorkData, setPaginationLeadTypeOfWorkData] =
    useState([]);
  const [editLeadDiscussionStationId, setEditLeadDiscussionStationId] =
    useState("");

  const [leadTypeOfWorkInputs, setLeadTypeOfWorkInputs] = useState({
    name: "",
  });

  const [passwordInputs, setPasswordInputs] = useState({
    password: "",
    password_confirmation: "",
  });

  const userId = JSON.parse(localStorage.getItem("user_id"));

  const fetchLeadTypeOfWork = async (page = 1) => {
    const token = localStorage.getItem("token");
    if (!token) {
      triggerToast("error", "Authorization token is missing", "error");
      toast.error("Authorization token is missing");
      return;
    }

    try {
      const apiUrl = searchData
        ? `public/api/salesmen\?page=${page}&search=${searchData}`
        : `public/api/salesmen?page=${page}`;

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });



      setLeadTypeOfWorkData(response.data.salesmen);
      setPaginationLeadTypeOfWorkData(response.data.salesmen);
    } catch (error) {
      triggerToast("error", "Error fetching lead sources", "error");
      // console.error("Error fetching lead sources:", error);
    }
  };

  useEffect(() => {
    fetchLeadTypeOfWork(currentPage);
  }, [searchData, currentPage]);

  const handleAddleadTypeOfWork = () => {
    setLeadTypeOfWorkButton("save");
    setLeadTypeOfWorkInputs({ setLeadTypeOfWorkInputs: "" });
    setIsDialogOpen(true);
  };

  const handleChangeForleadTypeOfWork = (e) => {
    setLeadTypeOfWorkInputs({
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveleadTypeOfWork = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      triggerToast("error", "Authorization token is missing", "error");
      // toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.post(
        "public/api/workers",
        leadTypeOfWorkInputs,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setIsDialogOpen(false);
      setErrors();
      triggerToast("success", "Workers added successfully", "success");
      // toast.success("leadTypeOfWork type added successfully");
      fetchLeadTypeOfWork();
    } catch (error) {
      triggerToast("error", "Failed to add Workers", "error");
      // console.error("Error adding leadTypeOfWork type:", error);
    }
  };

  const handleSubmitPasswordChange = async (e) => {
    const token = localStorage.getItem("token");
    if (!token) {
      triggerToast("error", "Authorization token is missing", "error");
      // toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.post(
        `public/api/set-password/${editLeadDiscussionStationId}`,
        passwordInputs,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );



      triggerToast("success", "Password changed successfully", "success");
      setIsPasswordDialogOpen(false);
    } catch (error) {
      triggerToast("error", "Failed to fetch lead source for editing", "error");

      // console.error("Error fetching leadTypeOfWork:", error);
      // toast.error("Failed to fetch lead source for editing");
    }
  };

  const handleOpenPassword = async (id_crypt) => {
    setIsPasswordDialogOpen(true);
    setEditLeadDiscussionStationId(id_crypt);
  };

  const handleChangePassword = async (e) => {
    setPasswordInputs({
      [e.target.name]: e.target.value,
    });
  };

  const handleEditleadTypeOfWork = async (id_crypt) => {
    setIsDialogOpen(true);
    setEditLeadDiscussionStationId(id_crypt);

    const token = localStorage.getItem("token");
    if (!token) {
      triggerToast("error", "Authorization token is missing", "error");
      // toast.error("Authorization token is missing");
      return;
    }

    try {
      const response = await axios.get(`public/api/type-of-works/${id_crypt}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });



      const leadTypeOfWorkData = response.data;

      // Correctly setting the state
      setLeadTypeOfWorkInputs({ name: leadTypeOfWorkData.name });

      setEditleadTypeOfWork(id_crypt);
      setLeadTypeOfWorkButton("update");
      setIsDialogOpen(true);
    } catch (error) {
      triggerToast("error", "Failed to fetch lead source for editing", "error");
      // console.error("Error fetching leadTypeOfWork:", error);
      // toast.error("Failed to fetch lead source for editing");
    }
  };

  const handleUpdateleadTypeOfWork = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    setLeadTypeOfWorkButton("update");

    try {
      const response = await axios.put(
        `public/api/salesmen/${editLeadDiscussionStationId}`,
        leadTypeOfWorkInputs,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        setIsDialogOpen(false);
        triggerToast("success", "Workers updated successfully", "success");
        // toast.success("leadTypeOfWork type updated successfully");
        await fetchLeadTypeOfWork();
      } else {
        triggerToast("error", "Failed to update Workers", "error");
        // toast.error("Failed to update leadTypeOfWork type");
      }
    } catch (error) {
      triggerToast("error", "Failed to update Workers", "error");
      // console.error(
      //   "Error updating leadTypeOfWork type:",
      //   error.response ? error.response.data : error
      // );
      // toast.error("Failed to update leadTypeOfWork type");
    }
  };

  const handlePageChange = async (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);
      setCurrentPage(newPage);
      await fetchLeadTypeOfWork(newPage);
    }
  };

  return (
    <>
      {/* <HeaderWithButton
        title="Sales Person"
        description="Sales Person"
        buttonText="Sales Person"
        onButtonClick={handleAddleadTypeOfWork}
        showButton={true}
      /> */}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-start sm:items-center mt-6">
        <div>
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Sales Person
          </h1>
          <p className="mt-2 text-sm text-gray-700">{`A list of all Sales Person report`}</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 items-start sm:items-center">
        <div className="mt-6 overflow-x-auto rounded-lg shadow">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                  S No
                </th>
                <th className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                  Sales Person Name
                </th>
                <th className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                  Sales Person ID
                </th>
                {(userId === 1 || userId === 2) && (
                  <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                    Actions
                  </th>
                )}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 ">
              {paginationLeadTypeOfWorkData?.data?.length > 0 ? (
                paginationLeadTypeOfWorkData.data.map(
                  (leadTypeOfWork, index) => (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                        {paginationLeadTypeOfWorkData.from + index}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                        {leadTypeOfWork.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                        {leadTypeOfWork.salesman_tally_id}
                      </td>
                      {/* {(userId === 1 || userId === 2) && (
                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                          <div className="relative group inline-block">
                            <button
                              onClick={() =>
                                handleOpenPassword(leadTypeOfWork.id_crypt)
                              }
                              className="text-indigo-600 hover:text-indigo-900 px-6 py-4"
                            >
                              <KeyIcon className="w-5 h-5" />
                            </button>
                            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-max max-w-xs bg-gray-800 text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50">
                              Reset Password
                            </div>
                          </div>
                        </td>
                      )} */}
                      {(userId == 1 || userId == 2) && (
                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">

                          <DeleteConfirmation
                            id_crypt={leadTypeOfWork.id_crypt}
                            apiType={"salesman"}
                            fetchClientData={fetchLeadTypeOfWork}
                          />

                        </td>
                      )}
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    className="px-6 py-4 text-center text-sm text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {isDialogOpen && (
          <Dialog
            open={isDialogOpen}
            onClose={() => setIsDialogOpen(false)}
            className="relative z-10"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-50 backdrop-blur-sm transition-opacity" />
            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                  <div
                    className="flex justify-between items-center mb-4 p-4"
                    style={{ backgroundColor: "#6366f1" }}
                  >
                    <h1 className=" text-white mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 uppercase z-100">
                      Type Of Work
                    </h1>
                    <button
                      type="button"
                      onClick={() => setIsDialogOpen(false)}
                    >
                      <XMarkIcon
                        className="h-6 w-6 sm:h-8 sm:w-8 text-white cursor-pointer"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                  <div className="w-full max-w-7xl mx-auto p-6 bg-gray-50">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                      <div className="sm:col-span-2">
                        <form>
                          <div className="overflow-hidden sm:rounded-md">
                            <div className="space-y-4">
                              <div>
                                <label
                                  htmlFor="leadTypeOfWork"
                                  className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                  Name
                                </label>
                                <div className="mt-2">
                                  <input
                                    name="name"
                                    type="text"
                                    value={leadTypeOfWorkInputs.name}
                                    onChange={handleChangeForleadTypeOfWork}
                                    autoComplete="mode"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                                {errors && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {errors}
                                  </p>
                                )}
                              </div>

                              <div className="flex  space-x-2">
                                {leadTypeOfWorkButton === "save" ? (
                                  <button
                                    onClick={handleSaveleadTypeOfWork}
                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Add
                                  </button>
                                ) : (
                                  <button
                                    onClick={handleUpdateleadTypeOfWork}
                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Update
                                  </button>
                                )}
                                <button
                                  type="button"
                                  onClick={() => setIsDialogOpen(false)}
                                  className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </div>
            </div>
          </Dialog>
        )}
      </div>
      {paginationLeadTypeOfWorkData && (
        <Pagination
          links={paginationLeadTypeOfWorkData.links}
          currentPage={paginationLeadTypeOfWorkData.current_page}
          totalResults={paginationLeadTypeOfWorkData.total}
          from={paginationLeadTypeOfWorkData.from}
          to={paginationLeadTypeOfWorkData.to}
          lastPage={paginationLeadTypeOfWorkData.last_page}
          onPageChange={handlePageChange}
        />
      )}
      {isPasswordDialogOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6 relative">
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              Change Password
            </h3>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                New Password
              </label>
              <input
                type="password"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                value={passwordInputs.password}
                onChange={(e) =>
                  setPasswordInputs({
                    ...passwordInputs,
                    password: e.target.value,
                  })
                }
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Confirm Password
              </label>
              <input
                type="password"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                value={passwordInputs.password_confirmation}
                onChange={(e) =>
                  setPasswordInputs({
                    ...passwordInputs,
                    password_confirmation: e.target.value,
                  })
                }
              />
            </div>

            <div className="flex justify-end gap-2">
              <button
                type="button"
                className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                onClick={() => setIsPasswordDialogOpen(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-4 py-2 text-sm bg-indigo-600 text-white rounded hover:bg-indigo-700"
                onClick={handleSubmitPasswordChange}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Salesman;
